/* global Excel */

import { applyBorders } from "@/utils/macro";

export async function indexMatch(context: Excel.RequestContext) {
  const sheetName = "Index Match";
  const sheets = context.workbook.worksheets;
  const existingSheet = sheets.getItemOrNullObject(sheetName);
  existingSheet.load("name");
  await context.sync();

  if (!existingSheet.isNullObject) {
    existingSheet.delete();
    await context.sync();
  }

  const sheet = sheets.add(sheetName);
  sheet.activate();

  const data = [
    ["Sales Amount", "Salesperson", "Sales ID", "Month", "Region"],
    [7000, "Colin", 53001, "October", "West"],
    [45000, "Mike", 53002, "October", "West"],
    [14000, "Diane", 53003, "October", "East"],
    [6000, "Wendy", 53004, "October", "East"],
    [20000, "Mike", 53005, "October", "West"],
    [5000, "Diane", 53006, "October", "East"],
    [8000, "Colin", 53007, "November", "West"],
    [9000, "Colin", 53008, "November", "West"],
    [6000, "Colin", 53009, "November", "West"],
    [34000, "Diane", 53010, "November", "East"],
    [12000, "Diane", 53011, "November", "East"],
    [40000, "Wendy", 53012, "November", "East"],
    [3000, "Wendy", 53013, "December", "East"],
    [15000, "Mike", 53014, "December", "West"],
    [16000, "Mike", 53015, "December", "West"],
    [12000, "Diane", 53016, "December", "East"],
    [18000, "Colin", 53017, "December", "West"],
    [50000, "Diane", 53018, "December", "East"],
    [19000, "Mike", 53019, "December", "West"],
  ];

  const tableRange = sheet.getRange("A1:E20");
  tableRange.values = data;
  tableRange.format.autofitColumns();
  tableRange.format.font.name = "Aptos Display";

  const description = sheet.getRange("F:N");
  description.format.font.name = "Arial";

  const header = sheet.getRange("A1:E1");
  header.format.font.bold = true;
  header.format.font.size = 12;
  header.format.horizontalAlignment = "Center";
  applyBorders(header, [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G1").values = [["Formula"]];
  sheet.getRange("G1").format.font.bold = true;
  sheet.getRange("G1").format.horizontalAlignment = "Center";

  const salesIDCell = sheet.getRange("I1");
  salesIDCell.values = [["SalesID"]];
  salesIDCell.format.font.bold = true;
  salesIDCell.format.horizontalAlignment = "Center";
  applyBorders(salesIDCell, [Excel.BorderIndex.edgeBottom]);

  const salesIDValue = sheet.getRange("I2");
  salesIDValue.values = [["53010"]];
  salesIDValue.format.horizontalAlignment = "Center";
  salesIDValue.format.font.color = "red";
  salesIDValue.format.font.bold = true;

  const formulaCell = sheet.getRange("G2");
  formulaCell.formulas = [["=INDEX(A2:A20,MATCH(I2,C2:C21,0))"]];
  formulaCell.format.fill.color = "#FFFF00";
  formulaCell.format.font.bold = true;
  formulaCell.numberFormat = [["$#,##0"]];
  formulaCell.format.horizontalAlignment = "Center";
  applyBorders(formulaCell, undefined, undefined, Excel.BorderWeight.medium);

  sheet.getRange("G4").values = [["Formula Purpose"]];
  sheet.getRange("G4").format.font.bold = true;
  sheet.getRange("G5").setCellProperties([
    [
      {
        textRuns: [
          {
            text: "To Find the the Sales Amount based on Sales ID",
          },
          { text: " 53010", font: { color: "red", bold: true } },
        ],
      },
    ],
  ]);

  const formulaLogicRange = sheet.getRange("G4:L4");
  sheet.getRange("G7").values = [["Formula Logic"]];
  sheet.getRange("G7").format.font.bold = true;
  sheet.getRange("G8").numberFormat = [["@"]];
  sheet.getRange("G8").setCellProperties([
    [
      {
        textRuns: [
          { text: "=INDEX(", font: { color: "black" } },
          { text: "column_to_return", font: { color: "blue" } },
          { text: ",", font: { color: "black" } },
          { text: "MATCH(" },
          { text: "lookup_value", font: { color: "red" } },
          { text: "," },
          { text: "column_to_search", font: { color: "purple" } },
          { text: ",0))" },
        ],
      },
    ],
  ]);
  applyBorders(formulaLogicRange, [Excel.BorderIndex.edgeBottom]);
  applyBorders(sheet.getRange("G7:L7"), [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G10").values = [["Sample Formula Inputs"]];
  sheet.getRange("G10").format.font.bold = true;
  sheet.getRange("G11").numberFormat = [["@"]];
  sheet.getRange("G11").setCellProperties([
    [
      {
        textRuns: [
          { text: "=INDEX(" },
          {
            text: "A2:A20",
            font: { color: "blue" },
          },
          { text: "," },
          { text: "MATCH(" },
          {
            text: "I2",
            font: { color: "red" },
          },
          { text: "," },
          {
            text: "C2:C21",
            font: { color: "purple" },
          },
          { text: "," },
          { text: "0))" },
        ],
      },
    ],
  ]);
  applyBorders(sheet.getRange("G10:L10"), [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G13").values = [["SheetShark Summary:"]];
  sheet.getRange("G13").format.font.bold = true;

  sheet.getRange("G14").setCellProperties([
    [
      {
        textRuns: [
          { text: "The formula looks for the value in" },
          {
            text: " I2",
            font: { color: "red", bold: true },
          },
          { text: " within" },
          {
            text: " C2:C20",
            font: { color: "purple", bold: true },
          },
        ],
      },
    ],
  ]);

  sheet.getRange("G15").setCellProperties([
    [
      {
        textRuns: [{ text: "Once it finds the exact match, it picks the corresponding" }],
      },
    ],
  ]);

  sheet.getRange("G16").setCellProperties([
    [
      {
        textRuns: [
          { text: "value from" },
          {
            text: " A2:A20",
            font: { color: "blue", bold: true },
          },
          { text: " at the same relative position." },
        ],
      },
    ],
  ]);

  applyBorders(sheet.getRange("G13:K17"));

  // Set all columns to a certain width for consistency
  sheet.getUsedRange().getEntireColumn().format.columnWidth = 80;

  // Center align B, C, D, E columns
  sheet.getRange("B:E").format.horizontalAlignment = "Center";

  // Format "Sales Amount" with currency prefix and two decimals
  sheet.getRange("A2:A20").numberFormat = [['_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)']];
  // Format "Formula" with currency prefix with no decimal
  sheet.getRange("G2").numberFormat = [['_($* #,##0_);_($* (#,##0.00);_($* "-"??_);_(@_)']];

  await context.sync();
}
